// extracted by mini-css-extract-plugin
export default {"radio":"SuperRadio_radio__Rb39R","label":"SuperRadio_label__6T++0","options":"SuperRadio_options__dJ0WX"};